import { SegmentAnalyitcs } from "./providers/segment";
import { AnalyticsAPI } from "./analytics.model";
import { EnsightenAnalytics } from "./providers/ensighten";
import { Store } from "./libs/store";

export interface Options {
  use: string[];
}

export class Analytics implements AnalyticsAPI {
  public providers: string[] = [];
  public store: Store;
  private _providers: any;

  constructor(private options?: Options) {
    this.store = new Store();
    this._providers = {
      segment: new SegmentAnalyitcs(this.store),
      ensighten: new EnsightenAnalytics()
    };

    if (this.options) {
      this.options.use.forEach(provider => {
        if (!this._providers[provider].test()) {
          throw `The provider ${provider} is not installed in the application`;
        }
        this.providers.push(provider);
      });
    }

    if (this.providers.length === 0) {
      this.providers.push("segment");
    }
  }

  group(groupId: string, traits: any): void {
    this.providers.forEach(provider => {
      this._providers[provider].group(groupId, traits);
    });
  }

  identify(userId: string, userProperties: any, isLazy: boolean): void {
    this.providers.forEach(provider => {
      this._providers[provider].identify(userId, userProperties, isLazy);
    });
  }

  track(eventName: string, eventProperties: any, isLazy: boolean): void {
    this.providers.forEach(provider => {
      this._providers[provider].track(eventName, eventProperties, isLazy);
    });
  }

  alias(userId: string, previousId: string): void {
    this.providers.forEach(provider => {
      this._providers[provider].alias(userId, previousId);
    });
  }

  page(category: string, name: string, properties: any): void {
    this.providers.forEach(provider => {
      this._providers[provider].page(category, name, properties);
    });
  }

  clearPendingCalls() {
    this.providers.forEach(provider => {
      if (this._providers[provider].clearPendingCalls) {
        this._providers[provider].clearPendingCalls();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/analytics.ts